import React from "react";

const EditFormSubmission = ({ submission, currentUser, onCancel, onUpdated }) => {
  const review = submission.reviews?.[0];

  const [formState, setFormState] = React.useState({
    id: review?.id || null,
    status: review?.status || '',
    notes: review?.notes || '',
  });

  const [fileUploadStatuses, setFileUploadStatuses] = React.useState(() => {
    return (submission.file_uploads || []).reduce((acc, upload) => {
      acc[upload.id] = upload.reviews?.[0]?.status || null;
      return acc;
    }, {});
  });
  
  React.useEffect(() => {
    const review = submission.reviews?.[0];
    setFormState({
      id: review?.id || null,
      status: review?.status || '',
      notes: review?.notes || '',
    });
  
    const uploads = submission.file_uploads || [];
    setFileUploadStatuses(
      uploads.reduce((acc, upload) => {
        const review = upload.reviews?.[0];
        acc[upload.id] = review?.status || null;
        return acc;
      }, {})
    );
  }, [submission]);

  const handleRadioChange = (value) => {
    setFormState((prev) => ({ ...prev, status: value }));
  };

  const handleNotesChange = (e) => {
    setFormState((prev) => ({ ...prev, notes: e.target.value }));
  };

  const handleFileReviewChange = (fileId, status) => {
    setFileUploadStatuses((prev) => ({ ...prev, [fileId]: status }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const organizationId = submission.form.organization.id;
    const userId = currentUser;

    const payload = {
      form_submission: {
        reviews_attributes: {
          0: {
            id: formState.id,
            organization_id: organizationId,
            user_id: userId,
            status: formState.status,
            notes: formState.notes,
          },
        },
        file_uploads_attributes: {},
      },
    };

    Object.entries(fileUploadStatuses).forEach(([fileId, status], index) => {
      const file = submission.file_uploads.find((f) => f.id === parseInt(fileId));
      const fileReview = file.reviews?.[0];

      payload.form_submission.file_uploads_attributes[index] = {
        id: file.id,
        reviews_attributes: {
          0: {
            id: fileReview?.id,
            organization_id: organizationId,
            user_id: userId,
            status,
          },
        },
      };
    });

    try {
      const res = await fetch(
        `/organizations/${submission.form.organization.name}/affiliate_members/${submission.submissionable_id}/form_submissions/${submission.id}.json`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        const updatedData = await res.json();
        onUpdated(updatedData);
        onCancel();
      } else {
        console.error("Failed to update:", await res.text());
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex justify-content-between">
      <a
          href={`/organizations/${submission.form.organization.name}/forms/${submission.form.token}/submissions/${submission.uuid}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <h4>{submission.form.title}</h4>
        </a>
        <div>
          <button className="btn btn-primary" type="submit">Save</button>
          <button className="btn btn-outline-secondary ml-2" type="button" onClick={onCancel}>Cancel</button>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-2">
          <b>Submitted Date</b>
          <div>{new Date(submission.created_at).toLocaleDateString()}</div>
        </div>
        <div className="col-md-2">
          <b>Form Accepted?</b>
          <div className="form-check">
            <input type="radio" className="form-check-input ml-1" checked={formState.status === "accepted"} onChange={() => handleRadioChange("accepted")} />
            <label className="form-check-label">Accepted</label>
          </div>
          <div className="form-check">
            <input type="radio" className="form-check-input ml-1" checked={formState.status === "declined"} onChange={() => handleRadioChange("declined")} />
            <label className="form-check-label">Rejected</label>
          </div>
        </div>

        <div className="col-md-6">
          <b>Notes</b>
          <textarea className="form-control" value={formState.notes} onChange={handleNotesChange} />
        </div>
      </div>

      <div className="mt-4">
        <b>File Uploads</b>
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>File Name</th>
              <th>Upload Accepted</th>
              <th>Upload Rejected</th>
            </tr>
          </thead>
          <tbody>
            {submission.file_uploads.map((file) => (
              <tr key={file.id}>
                <td>{file.name}</td>
                <td>
                  <a href={file.asset_url} target="_blank" rel="noopener noreferrer">
                    {file.asset_file_name}
                  </a>
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <label className="form-check-label">
                      <input
                        type="radio"
                        className="form-check-input"
                        name={`file-review-${file.id}`}
                        value="accepted"
                        checked={fileUploadStatuses[file.id] === "accepted"}
                        onChange={() => handleFileReviewChange(file.id, "accepted")}
                      />
                    </label>
                  </div>
                </td>
                <td>
                  <div className="d-flex gap-2">
                    <label className="form-check-label ml-3">
                      <input
                        type="radio"
                        className="form-check-input"
                        name={`file-review-${file.id}`}
                        value="declined"
                        checked={fileUploadStatuses[file.id] === "declined"}
                        onChange={() => handleFileReviewChange(file.id, "declined")}
                      />
                    </label>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </form>
  );
};

export default EditFormSubmission;
